import sgMail from '@sendgrid/mail'
//var fs = require('fs');'
var sendGridAPIKey ='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'
    
var EmailService = {
  accountReadyToUse:function($user)
  {
    var $template = fs.readFileSync('C:\\nodejs\\apps\\templates\\accountReady.html', 'utf8');
    $template  = $template.replace('{user}',$user.first_name)
    sgMail.setApiKey(sendGridAPIKey);
    const msg = {
      to: $user.email,
      from: 'support@tibura.com',
      subject: 'Your account with Tibura Identiti',
      text: 'Your account with Tibura Identiti',
      html: $template

     };
    sgMail.send(msg);
  },
  sendInvite:function($user) {
    console.log(JSON.stringify($user))
    var $template = fs.readFileSync('C:\\nodejs\\apps\\templates\\invite.html', 'utf8');
    $template  = $template.replace('{$activateKey}',$user.activation_key)
    sgMail.setApiKey(sendGridAPIKey);
    const msg = {
      to: $user.email,
      from: 'support@tibura.com',
      subject: 'Please verify your account with Tibura Identiti',
      text: 'and easy to do anywhere, even with Node.js',
      html: $template

     };
    sgMail.send(msg);
  },
  sendInvite1:function($user)
   {
     console.log($user);
     $options = {}
     $options.to = $user.email
     $options.text =''
     $options.subject ='You are Inviited to use Tibura Identiti'
     $options.html ='<strong>Thanks for Signing up with Tibura Identiti!</strong><br/>Activation Key '+$user.activation_key
     console.log($options)
     sendEmail($options)
   },
   send:function($options){

       sendEmail($options)
   },
   password:function($mail) {
    //var $template = fs.readFileSync('../../templates/password.html', 'utf8');
    //$template  = $template.replace('{email}',$mail)
    var $template=''
    $template='You are receiving this email because your have requested to reset your password associated with the Tibura Apps. <br/> \
     \
    Your account belongs to company Intranet Account and this request is forwarded to the Intranet administrator. <br/>\
    '
    sgMail.setApiKey(sendGridAPIKey);
    const msg = {
      to: $mail,
      from: 'support@tibura.com',
      subject: 'Your account with Tibura Apps',
      text: 'Your account with Tibura Apps',
      html: $template

     };
    sgMail.send(msg);

   }

};
export default EmailService;
var sendEmail = function($options)
  {
    //const sgMail = require('@sendgrid/mail');
    
    try {
    sgMail.setApiKey(sendGridAPIKey);
    console.log($options)
    const msg = {
    to: $options.to,
    from: 'support@tibura.com',
    subject: $options.subject,
    text: $options.text,
    html: $options.text,
    attachments: $options.attachment
  };
  sgMail.send(msg)

} catch(exceptin) {
  console.log('there is an error')
  console.log(exception)
}
}
